export type Lang = "ar" | "he";

const translations = {
  ar: {
    nav: {
      home: "الرئيسية",
      about: "من نحن",
      practice: "مجالات التخصص",
      contact: "اتصل بنا",
    },
    hero: {
      badge: "تمثيل قانوني مهني وشخصي",
      title1: "المحامي علاء عودة",
      title2: "أضرار، مرور وقانون العمل",
      subtitle: "مكتب المحامي علاء عودة يقدم مرافقة قانونية شاملة ومهنية في مجالات القانون المدني والتجاري والجنائي. خبرة، إخلاص ونتائج.",
      cta1: "حدد موعد استشارة",
      cta2: "مجالات التخصص",
    },
    about: {
      label: "عن المكتب",
      title1: "خبرة مثبتة،",
      title2: "نهج شخصي",
      p1: "المحامي علاء عودة هو محامٍ ذو خبرة واسعة ومقدّر، متخصص في مجالات قانونية متنوعة. يقدم المكتب مرافقة قانونية شخصية ومهنية، مع الحفاظ على أعلى معايير التميز والموثوقية والالتزام الكامل تجاه العملاء.",
      p2: "نؤمن بأن كل عميل يستحق تمثيلاً ممتازاً، ولذلك نستثمر في كل قضية كامل الاهتمام والخبرة والإخلاص المطلوب لتحقيق أفضل النتائج.",
    },
    practice: {
      label: "ماذا نفعل",
      title1: "مجالات",
      title2: "التخصص",
      areas: [
        { title: "أضرار", desc: "تمثيل في دعاوى حوادث الطرق، حوادث العمل والإهمال الطبي. استنفاد كامل الحقوق في التعويضات." },
        { title: "دائره الاجراء والتنفيذ", desc: "تمثيل المدينين والدائنين في إجراءات التنفيذ، الحجز، ترتيبات الديون وتنفيذ الأحكام القضائية." },
        { title: "مخالفات سير", desc: "تمثيل في مخالفات المرور، القيادة تحت تأثير الكحول، سحب الرخصة والاستئنافات على الغرامات." },
        { title: "تأمين وطني", desc: "دعاوى إعاقة، مخصصات، لجان طبية واستئنافات أمام مؤسسة التأمين الوطني." },
        { title: "قانون العمل", desc: "تمثيل في نزاعات العمل، الفصل التعسفي، حقوق العمال ودعاوى الأجور." },
        { title: "إعسار مالي", desc: "مرافقة في إجراءات إعادة التأهيل الاقتصادي، الإعفاء من الديون والتمثيل في المحاكم." },
      ],
    },
    contact: {
      label: "يسعدنا سماع صوتك",
      title1: "اتصل",
      title2: "بنا",
      description: "مرحباً بكم للتواصل معنا لتحديد موعد استشارة أولية. نحن هنا لمساعدتكم في أي سؤال قانوني.",
      phone: "054-888-8325",
      phoneLabel: "اتصل الآن",
      emailLabel: "أرسل بريداً إلكترونياً",
      address: "كوكب أبو الهيجاء، ص.ب 422",
      addressLabel: "عنوان المكتب",
      nameLabel: "الاسم الكامل *",
      namePlaceholder: "أدخل الاسم الكامل",
      phoneFieldLabel: "الهاتف *",
      phonePlaceholder: "أدخل رقم الهاتف",
      subjectLabel: "موضوع التواصل",
      subjectDefault: "اختر موضوعاً",
      subjects: {
        insolvency: "إعسار مالي",
        execution: "دائره الاجراء والتنفيذ",
        insurance: "تأمين وطني",
        traffic: "مخالفات سير",
        labor: "قانون العمل",
        torts: "أضرار",
        other: "أخرى",
      },
      emailFieldLabel: "البريد الإلكتروني",
      emailPlaceholder: "أدخل عنوان البريد الإلكتروني",
      messageLabel: "محتوى الرسالة *",
      messagePlaceholder: "اكتب محتوى رسالتك",
      submit: "أرسل الرسالة",
      submitting: "جارٍ الإرسال...",
      successTitle: "تم إرسال الرسالة بنجاح!",
      successDesc: "سنتواصل معك في أقرب وقت ممكن.",
      sendAnother: "إرسال رسالة أخرى",
      errorRequired: "يرجى ملء جميع الحقول المطلوبة",
      errorTooLong: "أحد الحقول طويل جداً",
      errorEmail: "عنوان بريد إلكتروني غير صالح",
      errorSubmit: "حدث خطأ في إرسال الرسالة. حاول مرة أخرى.",
      toastSuccess: "تم إرسال الرسالة بنجاح! سنتواصل معك قريباً.",
    },
    footer: {
      description: "تمثيل قانوني مهني وشخصي في مجالات الأضرار، المرور، قانون العمل والمزيد.",
      quickNav: "تصفح سريع",
      contactInfo: "معلومات الاتصال",
      accessibilityStatement: "بيان إمكانية الوصول",
      privacyPolicy: "سياسة الخصوصية",
      terms: "شروط الاستخدام",
      copyright: "المحامي علاء عودة | جميع الحقوق محفوظة",
    },
    accessibility: {
      title: "إمكانية الوصول",
      menuLabel: "قائمة إمكانية الوصول",
      closeMenu: "إغلاق قائمة إمكانية الوصول",
      fontSize: "حجم الخط",
      decrease: "تصغير",
      increase: "تكبير",
      highContrast: "تباين عالٍ",
      highlightLinks: "تمييز الروابط",
      largeCursor: "مؤشر كبير",
      reset: "إعادة تعيين الإعدادات",
      statement: "بيان إمكانية الوصول",
    },
    whatsapp: "مرحباً، أود الحصول على استشارة قانونية",
    whatsappLabel: "أرسل رسالة عبر واتساب",
    langToggle: "עברית",

    seo: {
      home: {
        title: "المحامي علاء عودة | أضرار، مرور، قانون العمل",
        description: "مكتب المحامي علاء عودة، تخصص في الأضرار، تنفيذ الأحكام، المرور، التأمين الوطني، قانون العمل والإعسار المالي. استشارة قانونية مهنية.",
      },
      privacy: {
        title: "سياسة الخصوصية | المحامي علاء عودة",
        description: "سياسة الخصوصية لموقع المحامي علاء عودة — كيف نجمع ونستخدم ونحمي معلوماتك الشخصية.",
      },
      terms: {
        title: "شروط الاستخدام | المحامي علاء عودة",
        description: "شروط استخدام موقع المحامي علاء عودة — القواعد والأحكام التي تحكم استخدامك للموقع وخدماته.",
      },
      accessibility: {
        title: "إمكانية الوصول | المحامي علاء عودة",
        description: "بيان إمكانية الوصول لموقع المحامي علاء عودة — التزامنا بمعايير WCAG 2.1 AA وإتاحة الموقع لجميع المستخدمين.",
      },
    },

    // Static pages
    accessibilityPage: {
      back: "العودة إلى الصفحة الرئيسية",
      title1: "بيان",
      title2: "إمكانية الوصول",
      generalTitle: "عام",
      generalText: "مكتب المحامي علاء عودة ملتزم بإتاحة الموقع للأشخاص ذوي الإعاقة، وفقاً لقانون المساواة في الحقوق للأشخاص ذوي الإعاقة ولوائح المساواة في الحقوق.",
      standardTitle: "معيار إمكانية الوصول",
      standardText: "يتوافق الموقع مع متطلبات لوائح المساواة في الحقوق للأشخاص ذوي الإعاقة، بمستوى AA من معيار WCAG 2.1.",
      featuresTitle: "ميزات إمكانية الوصول في الموقع",
      features: [
        "توافق مع قارئات الشاشة والتقنيات المساعدة",
        "تصفح باستخدام لوحة المفاتيح",
        "إمكانية تكبير وتصغير النص",
        "تغيير تباين الألوان",
        "تمييز الروابط",
        "مؤشر مكبّر",
        "بنية دلالية للعناوين والمحتوى",
        "نصوص بديلة للصور (alt text)",
      ],
      contactTitle: "التواصل بشأن إمكانية الوصول",
      contactText: "إذا واجهتم مشكلة في إمكانية الوصول في الموقع، يسعدنا تلقي تواصلكم.",
      coordinator: "منسق إمكانية الوصول:",
      coordinatorName: "المحامي علاء عودة",
      phoneLabel: "الهاتف:",
      emailLabel: "البريد الإلكتروني:",
      addressLabel: "العنوان:",
      address: "كوكب أبو الهيجاء، ص.ب 422",
      updatedTitle: "تاريخ تحديث البيان",
      updatedText: "تم تحديث بيان إمكانية الوصول هذا في: فبراير 2026.",
    },
    privacyPage: {
      back: "العودة إلى الصفحة الرئيسية",
      title: "سياسة الخصوصية",
      updated: "آخر تحديث: 18 فبراير 2026",
      sections: [
        { title: "1. مقدمة", content: "مكتب المحامي علاء عودة (\"المكتب\"، \"نحن\") يحترم خصوصية مستخدمي موقعنا. توضح سياسة الخصوصية هذه كيف نجمع ونستخدم ونحمي معلوماتك الشخصية." },
        { title: "2. المعلومات التي نجمعها", content: "قد نجمع أنواع المعلومات التالية:", list: ["معلومات شخصية: الاسم، رقم الهاتف، البريد الإلكتروني وتفاصيل الاتصال الأخرى.", "معلومات تقنية: عنوان IP، نوع المتصفح وبيانات استخدام الموقع.", "بيانات تقويم Google: إذا اخترت ربط حسابك في Google."] },
        { title: "3. استخدام المعلومات", content: "نستخدم المعلومات المجمعة للأغراض التالية:", list: ["الرد على الاستفسارات والطلبات", "إدارة القضايا والأحداث", "مزامنة الأحداث مع تقويم Google (بموافقتك)", "تحسين تجربة المستخدم"] },
        { title: "4. استخدام بيانات Google", content: "يطلب تطبيقنا الوصول إلى تقويم Google الخاص بك فقط لغرض مزامنة الأحداث القانونية.", list: ["نصل فقط إلى أحداث التقويم", "لا نشارك بيانات Google مع أطراف ثالثة", "لا نستخدم البيانات لأغراض إعلانية", "يمكنك فصل الاتصال في أي وقت", "نحذف الرموز فوراً عند فصل الحساب"] },
        { title: "5. أمن المعلومات", content: "نتخذ تدابير أمنية معقولة لحماية معلوماتك الشخصية، بما في ذلك التشفير والوصول المحدود واستخدام بروتوكولات آمنة (HTTPS)." },
        { title: "6. مشاركة المعلومات مع أطراف ثالثة", content: "لا نبيع أو نتاجر أو ننقل معلوماتك الشخصية لأطراف ثالثة، إلا في الحالات التالية:", list: ["عندما يكون مطلوباً بموجب القانون أو أمر المحكمة", "مقدمو الخدمات العاملون بالنيابة عنا والملتزمون بالسرية"] },
        { title: "7. حقوقك", content: "لديك الحق في:", list: ["طلب الوصول إلى معلوماتك الشخصية", "طلب تصحيح أو حذف معلوماتك", "إلغاء موافقتك في أي وقت", "فصل حساب Google الخاص بك"] },
        { title: "8. اتصل بنا", content: "لأي أسئلة بخصوص سياسة الخصوصية هذه:" },
      ],
    },
    termsPage: {
      back: "العودة إلى الصفحة الرئيسية",
      title: "شروط الاستخدام",
      updated: "آخر تحديث: 18 فبراير 2026",
      sections: [
        { title: "1. مقدمة", content: "مرحباً بكم في موقع مكتب المحامي علاء عودة (\"الموقع\"). استخدام هذا الموقع خاضع لشروط الاستخدام المفصلة أدناه." },
        { title: "2. وصف الخدمة", content: "يوفر الموقع:", list: ["معلومات عن خدمات المكتب ومجالات الممارسة", "نموذج اتصال للاستفسارات الأولية", "نظام إدارة القضايا والأحداث للعملاء", "إمكانية المزامنة مع تقويم Google (اختياري)"] },
        { title: "3. التسجيل وحساب المستخدم", content: "تتطلب بعض الخدمات التسجيل. أنت مسؤول عن الحفاظ على سرية بيانات تسجيل الدخول الخاصة بك." },
        { title: "4. خدمات Google", content: "يوفر الموقع إمكانية ربط حساب Google لمزامنة الأحداث.", list: ["توافق على منحنا الوصول إلى أحداث التقويم فقط", "يمكنك فصل الاتصال في أي وقت", "فصل الاتصال سيحذف جميع الرموز المخزنة"] },
        { title: "5. الملكية الفكرية", content: "جميع المحتويات في الموقع هي ملك للمكتب ومحمية بموجب قوانين الملكية الفكرية." },
        { title: "6. تحديد المسؤولية", content: "المعلومات في هذا الموقع هي لأغراض المعلومات العامة فقط ولا تشكل استشارة قانونية. الموقع مقدم \"كما هو\" (AS IS)." },
        { title: "7. تغييرات في شروط الاستخدام", content: "يحق للمكتب تحديث شروط الاستخدام هذه من وقت لآخر." },
        { title: "8. القانون المعمول به والاختصاص القضائي", content: "تخضع شروط الاستخدام هذه لقوانين دولة إسرائيل. الاختصاص القضائي الحصري للمحاكم المختصة في المنطقة الشمالية." },
        { title: "9. اتصل بنا", content: "لأي أسئلة بخصوص شروط الاستخدام هذه:" },
      ],
    },
  },
  he: {
    nav: {
      home: "ראשי",
      about: "אודות",
      practice: "תחומי התמחות",
      contact: "צור קשר",
    },
    hero: {
      badge: "ייצוג משפטי מקצועי ואישי",
      title1: "עו״ד עלאא עודה",
      title2: "נזיקין, תעבורה ודיני עבודה",
      subtitle: "משרד עו\"ד עלאא עודה מציע ליווי משפטי מקיף ומקצועי בתחומי המשפט האזרחי, המסחרי והפלילי. ניסיון, מסירות ותוצאות.",
      cta1: "קבע פגישת ייעוץ",
      cta2: "תחומי התמחות",
    },
    about: {
      label: "אודות המשרד",
      title1: "ניסיון מוכח,",
      title2: "גישה אישית",
      p1: "עו\"ד עלאא עודה הוא עורך דין מנוסה ומוערך, המתמחה במגוון תחומי משפט. המשרד מציע ליווי משפטי אישי ומקצועי, תוך שמירה על סטנדרטים גבוהים של מצוינות, אמינות ומחויבות מלאה ללקוחות.",
      p2: "אנו מאמינים שכל לקוח ראוי לייצוג מעולה, ולכן אנו משקיעים בכל תיק את מלוא תשומת הלב, המומחיות והמסירות הנדרשת להשגת התוצאות הטובות ביותר.",
    },
    practice: {
      label: "מה אנחנו עושים",
      title1: "תחומי",
      title2: "התמחות",
      areas: [
        { title: "נזיקין", desc: "ייצוג בתביעות תאונות דרכים, תאונות עבודה ורשלנות רפואית. מיצוי מלוא הזכויות לפיצויים." },
        { title: "הוצאה לפועל", desc: "ייצוג חייבים וזוכים בהליכי הוצאה לפועל, עיקולים, הסדרי חוב ומימוש פסקי דין." },
        { title: "תעבורה", desc: "ייצוג בעבירות תנועה, נהיגה בשכרות, שלילת רישיון וערעורים על קנסות." },
        { title: "ביטוח לאומי", desc: "תביעות נכות, קצבאות, ועדות רפואיות וערעורים מול המוסד לביטוח לאומי." },
        { title: "דיני עבודה", desc: "ייצוג בסכסוכי עבודה, פיטורים שלא כדין, זכויות עובדים ותביעות שכר." },
        { title: "חדלות פירעון", desc: "ליווי בהליכי שיקום כלכלי, הפטר מחובות וייצוג בבתי משפט." },
      ],
    },
    contact: {
      label: "נשמח לשמוע ממך",
      title1: "צור",
      title2: "קשר",
      description: "מוזמנים לפנות אלינו לקביעת פגישת ייעוץ ראשונית. אנו כאן כדי לסייע לכם בכל שאלה משפטית.",
      phone: "054-888-8325",
      phoneLabel: "התקשרו עכשיו",
      emailLabel: "שלחו מייל",
      address: "כאוכב אבו אלהיגא, ת.ד 422",
      addressLabel: "כתובת המשרד",
      nameLabel: "שם מלא *",
      namePlaceholder: "הכנס שם מלא",
      phoneFieldLabel: "טלפון *",
      phonePlaceholder: "הכנס מספר טלפון",
      subjectLabel: "נושא הפניה",
      subjectDefault: "בחר נושא",
      subjects: {
        insolvency: "חדלות פרעון",
        execution: "הוצאה לפועל",
        insurance: "ביטוח לאומי",
        traffic: "תעבורה",
        labor: "עבודה",
        torts: "נזיקין",
        other: "אחר",
      },
      emailFieldLabel: "אימייל",
      emailPlaceholder: "הכנס כתובת אימייל",
      messageLabel: "תוכן הפנייה *",
      messagePlaceholder: "כתוב את תוכן הפנייה",
      submit: "שלח פנייה",
      submitting: "שולח...",
      successTitle: "הפנייה נשלחה בהצלחה!",
      successDesc: "ניצור איתך קשר בהקדם האפשרי.",
      sendAnother: "שליחת פנייה נוספת",
      errorRequired: "נא למלא את כל השדות הנדרשים",
      errorTooLong: "אחד מהשדות ארוך מדי",
      errorEmail: "כתובת מייל לא תקינה",
      errorSubmit: "אירעה שגיאה בשליחת הפנייה. נסו שוב.",
      toastSuccess: "הפנייה נשלחה בהצלחה! ניצור איתך קשר בהקדם.",
    },
    footer: {
      description: "ייצוג משפטי מקצועי ואישי בתחומי נזיקין, תעבורה, דיני עבודה ועוד.",
      quickNav: "ניווט מהיר",
      contactInfo: "פרטי קשר",
      accessibilityStatement: "הצהרת נגישות",
      privacyPolicy: "מדיניות פרטיות",
      terms: "תנאי שימוש",
      copyright: "עו\"ד עלאא עודה | כל הזכויות שמורות",
    },
    accessibility: {
      title: "נגישות",
      menuLabel: "תפריט נגישות",
      closeMenu: "סגור תפריט נגישות",
      fontSize: "גודל טקסט",
      decrease: "הקטן",
      increase: "הגדל",
      highContrast: "ניגודיות גבוהה",
      highlightLinks: "הדגשת קישורים",
      largeCursor: "סמן מוגדל",
      reset: "איפוס הגדרות",
      statement: "הצהרת נגישות",
    },
    whatsapp: "שלום, אשמח לקבל ייעוץ משפטי",
    whatsappLabel: "שלח הודעה בוואטסאפ",
    langToggle: "العربية",

    seo: {
      home: {
        title: "עו״ד עלאא עודה | נזיקין, תעבורה, דיני עבודה",
        description: "משרד עו״ד עלאא עודה — התמחות בנזיקין, הוצאה לפועל, תעבורה, ביטוח לאומי, דיני עבודה וחדלות פירעון. ייעוץ משפטי מקצועי.",
      },
      privacy: {
        title: "מדיניות פרטיות | עו״ד עלאא עודה",
        description: "מדיניות הפרטיות של אתר עו״ד עלאא עודה — כיצד אנו אוספים, משתמשים ומגנים על המידע האישי שלך.",
      },
      terms: {
        title: "תנאי שימוש | עו״ד עלאא עודה",
        description: "תנאי השימוש באתר עו״ד עלאא עודה — הכללים והתנאים החלים על השימוש באתר ובשירותיו.",
      },
      accessibility: {
        title: "הצהרת נגישות | עו״ד עלאא עודה",
        description: "הצהרת הנגישות של אתר עו״ד עלאא עודה — מחויבותנו לתקן WCAG 2.1 AA והנגשת האתר לכלל המשתמשים.",
      },
    },

    accessibilityPage: {
      back: "חזרה לדף הבית",
      title1: "הצהרת",
      title2: "נגישות",
      generalTitle: "כללי",
      generalText: "משרד עו\"ד עלאא עודה מחויב להנגשת האתר לאנשים עם מוגבלויות, בהתאם לחוק שוויון זכויות לאנשים עם מוגבלות, התשנ\"ח-1998, ובהתאם לתקנות שוויון זכויות לאנשים עם מוגבלות (התאמות נגישות לשירות), התשע\"ג-2013.",
      standardTitle: "תקן הנגישות",
      standardText: "האתר עומד בדרישות תקנות שוויון זכויות לאנשים עם מוגבלות (התאמות נגישות לשירות), התשע\"ג-2013, ברמת AA של תקן WCAG 2.1 ובהתאם לתקן הישראלי ת\"י 5568.",
      featuresTitle: "התאמות הנגישות באתר",
      features: [
        "התאמה לקוראי מסך ולטכנולוגיות מסייעות",
        "ניווט באמצעות מקלדת",
        "אפשרות להגדלה והקטנה של טקסט",
        "שינוי ניגודיות צבעים",
        "הדגשת קישורים",
        "סמן מוגדל",
        "מבנה סמנטי של כותרות ותוכן",
        "תיאורי תמונות חלופיים (alt text)",
      ],
      contactTitle: "דרכי פנייה לנושא נגישות",
      contactText: "אם נתקלתם בבעיית נגישות באתר, נשמח לקבל את פנייתכם כדי שנוכל לטפל בנושא.",
      coordinator: "רכז נגישות:",
      coordinatorName: "עו\"ד עלאא עודה",
      phoneLabel: "טלפון:",
      emailLabel: "דוא\"ל:",
      addressLabel: "כתובת:",
      address: "כאוכב אבו אלהיגא, ת.ד 422",
      updatedTitle: "תאריך עדכון ההצהרה",
      updatedText: "הצהרת נגישות זו עודכנה בתאריך: פברואר 2026.",
    },
    privacyPage: {
      back: "חזרה לעמוד הראשי",
      title: "מדיניות פרטיות",
      updated: "עודכן לאחרונה: 18 בפברואר 2026",
      sections: [
        { title: "1. מבוא", content: "משרד עורכי דין עלאא עודה (\"המשרד\", \"אנחנו\") מכבד את פרטיות המשתמשים באתר שלנו. מדיניות פרטיות זו מסבירה כיצד אנו אוספים, משתמשים ומגנים על המידע האישי שלך." },
        { title: "2. מידע שאנו אוספים", content: "אנו עשויים לאסוף את סוגי המידע הבאים:", list: ["מידע אישי: שם, מספר טלפון, כתובת דוא\"ל ופרטי פנייה אחרים.", "מידע טכני: כתובת IP, סוג דפדפן, ונתוני שימוש באתר.", "נתוני יומן Google: אם תבחר לחבר את חשבון Google שלך."] },
        { title: "3. שימוש במידע", content: "אנו משתמשים במידע שנאסף למטרות הבאות:", list: ["מתן מענה לפניות ובקשות", "ניהול תיקים ואירועים", "סנכרון אירועים עם יומן Google (בהסכמתך בלבד)", "שיפור חוויית המשתמש באתר"] },
        { title: "4. שימוש בנתוני Google", content: "האפליקציה שלנו מבקשת גישה ליומן Google שלך אך ורק לצורך סנכרון אירועים משפטיים.", list: ["ניגשים רק לאירועים ביומן שלך", "לא משתפים את נתוני Google שלך עם צדדים שלישיים", "לא משתמשים בנתונים למטרות פרסום", "מאפשרים לך לנתק את החיבור בכל עת", "מוחקים את הטוקנים שלך מיד עם ניתוק החשבון"] },
        { title: "5. אבטחת מידע", content: "אנו נוקטים באמצעי אבטחה סבירים כדי להגן על המידע האישי שלך, כולל הצפנה, גישה מוגבלת ושימוש בפרוטוקולים מאובטחים (HTTPS)." },
        { title: "6. שיתוף מידע עם צדדים שלישיים", content: "אנו לא מוכרים, סוחרים או מעבירים את המידע האישי שלך לצדדים שלישיים, למעט:", list: ["כאשר נדרש על פי חוק או צו בית משפט", "ספקי שירות הפועלים בשמנו ומחויבים לשמור על סודיות"] },
        { title: "7. זכויותיך", content: "יש לך את הזכות:", list: ["לבקש גישה למידע האישי שלך", "לבקש תיקון או מחיקה של המידע שלך", "לבטל את הסכמתך בכל עת", "לנתק את חשבון Google שלך מהמערכת"] },
        { title: "8. יצירת קשר", content: "לשאלות בנוגע למדיניות פרטיות זו, ניתן לפנות אלינו:" },
      ],
    },
    termsPage: {
      back: "חזרה לעמוד הראשי",
      title: "תנאי שימוש",
      updated: "עודכן לאחרונה: 18 בפברואר 2026",
      sections: [
        { title: "1. מבוא", content: "ברוכים הבאים לאתר משרד עורכי דין עלאא עודה (\"האתר\"). השימוש באתר זה כפוף לתנאי השימוש המפורטים להלן." },
        { title: "2. תיאור השירות", content: "האתר מספק:", list: ["מידע אודות שירותי המשרד ותחומי הפרקטיקה", "טופס יצירת קשר לפניות ראשוניות", "מערכת ניהול תיקים ואירועים עבור לקוחות המשרד", "אפשרות סנכרון עם יומן Google (אופציונלי)"] },
        { title: "3. הרשמה וחשבון משתמש", content: "חלק מהשירותים באתר דורשים הרשמה. אתה אחראי לשמור על סודיות פרטי ההתחברות שלך." },
        { title: "4. שירותי Google", content: "האתר מציע אפשרות לחבר את חשבון Google שלך לצורך סנכרון אירועים.", list: ["אתה מאשר לנו גישה לאירועי היומן שלך בלבד", "ניתן לנתק את החיבור בכל עת", "ניתוק החיבור ימחק את כל הטוקנים השמורים"] },
        { title: "5. קניין רוחני", content: "כל התכנים באתר הם רכוש המשרד ומוגנים על ידי חוקי קניין רוחני." },
        { title: "6. הגבלת אחריות", content: "המידע באתר זה הוא לצרכי מידע כללי בלבד ואינו מהווה ייעוץ משפטי. האתר מסופק \"כמות שהוא\" (AS IS)." },
        { title: "7. שינויים בתנאי השימוש", content: "המשרד רשאי לעדכן תנאי שימוש אלה מעת לעת." },
        { title: "8. דין חל וסמכות שיפוט", content: "תנאי שימוש אלה כפופים לדיני מדינת ישראל. סמכות השיפוט הבלעדית לבתי המשפט המוסמכים במחוז הצפון." },
        { title: "9. יצירת קשר", content: "לשאלות בנוגע לתנאי שימוש אלה, ניתן לפנות אלינו:" },
      ],
    },
  },
} as const;

export default translations;
